// extracted by mini-css-extract-plugin
export default {"content":"addName_content__L9SUT","name":"addName_name__t8BaG","submit":"addName_submit__V-8ln"};